<tt-card [ttHeading]="get?.webpage_heading ?? '...'" ttTranslateHeading="false">
    <ng-container *ngIf="!!get">
        <tt-input ttLabel="custgrp2_keyno" [ttModel]="get.custgrp2_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="custgrp2_name" [(ttModel)]="get.custgrp2_name">
            <ng-container buttons>
                <tt-form-field-button
                    *ngIf="get.custgrp2_keyno !== '0'"
                    ttIcon="fas fa-language"
                    ttTooltip="translate"
                    [ttTranslateTooltip]="true"
                    (ttClick)="openTranslateDialog()"
                ></tt-form-field-button>
            </ng-container>
        </tt-input>
        <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
        <tt-button *ngIf="get.custgrp2_keyno !== '0'" ttType="danger" ttText="delete" ttIcon="fad fa-trash" (ttClick)="deleteValues()" [ttLoading]="deleting"></tt-button>
    </ng-container>
    <ng-container *ngIf="!get">
        <ng-container [ngTemplateOutlet]="inputskeleton"></ng-container>
        <ng-container [ngTemplateOutlet]="inputskeleton"></ng-container>

        <div class="tt-skeleton" style="height: var(--tt-height); width: 100%; background-color: var(--tt-success-color); opacity: 0.2; margin-bottom: 7px"></div>
    </ng-container>
</tt-card>

<ng-template #inputskeleton>
    <div class="col-xs-12 sp-0 tt-skeleton" style="height: var(--tt-height); margin-bottom: 7px"></div>
</ng-template>
